enum SupportedManagement {
  LOCAL = "LOCAL",
  AZURE = "AZURE",
  GOOGLE = "GOOGLE",
  OKTA = "OKTA",
  SLACK = "SLACK",
}

export default SupportedManagement;
